import { render } from "./ContentPolicy.vue?vue&type=template&id=447d7cac&scoped=true"
import script from "./ContentPolicy.vue?vue&type=script&lang=js"
export * from "./ContentPolicy.vue?vue&type=script&lang=js"

import "./ContentPolicy.vue?vue&type=style&index=0&id=447d7cac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-447d7cac"]])

export default __exports__